export var proxyType = process.env.PROXY_TYPE;
export var apiEnv = process.env.API_ENV || 'test';
export var deployEnv = process.env.DEPLOY_ENV;
